import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataAccessProductsComponent } from './data-access-products/data-access-products.component';
import { ProductData } from '@equipmyschool/emsadminweb-models';

@Component({
  selector: 'app-data-access-wrapper-dialog',
  templateUrl: './data-access-wrapper-dialog.component.html',
  styleUrls: ['./data-access-wrapper-dialog.component.scss']
})
export class DataAccessWrapperDialogComponent {
  @ViewChild(DataAccessProductsComponent) child!: DataAccessProductsComponent;
  public id: number | null;

  constructor(public dialogRef: MatDialogRef<DataAccessWrapperDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.id = data;
  }

  async save(): Promise<void> {
    if (!this.child || !(await this.child.validate())) return;
    try {
      const saved: ProductData = await this.child.save();
      this.dialogRef.close(saved);
    } catch (e) {
      console.error('Save failed', e);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
